import { createBrowserHistory } from 'history'

// Determine basename based on environment
const basename = process.env.NODE_ENV === 'production' 
  ? '/find-an-ifa'  // Production: https://allangray.co.za/find-an-ifa/
  : '/'              // Development: http://localhost:3001/

let history

// Only create history in browser environment
if (typeof window !== 'undefined') {
  history = createBrowserHistory({ basename })
  
  // Listen for changes to the current location
  history.listen(() => {
    const sidebarContentContainer = document.getElementsByClassName('sidebar-content-container')[0]
    if (sidebarContentContainer) {
      sidebarContentContainer.scrollTop = 0
    }
  })
}

export default history
